import Html from '../Icons/Html'
import React from '../Icons/React'
import Css from '../Icons/Css'
import Tailwind from '../Icons/Tailwind'
import Wordpress from '../Icons/Wordpress'
import Python from '../Icons/Python'
import Firebase from '../Icons/Firebase'
import Node from '../Icons/Node'
import Java from '../Icons/Java'
import MySql from '../Icons/MySql'
import Mongodb from '../Icons/Mongodb'

const SkillsIco = () => {
  return (
    <>
      <div>
        <Python />
      </div>
      <div>
        <Html />
      </div>
      <div>
        <React />
      </div>
      <div>
        <Css />
      </div>
      <div>
        <Tailwind />
      </div>
      <div>
        <Wordpress />
      </div>
      <div>
        <Firebase />
      </div>
      <div>
        <Node />
      </div>
      <div>
        <Java />
      </div>
      <div>
        <MySql />
      </div>
      <div>
        <Mongodb />
      </div>
    </>
  )
}

export default SkillsIco
